import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "table"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.has_error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.invoices.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("thead", { class: "bg-secondary text-white" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Title"),
                        _createElementVNode("th", null, "Date Requested"),
                        _createElementVNode("th", null, "Status"),
                        _createElementVNode("th", null, "-")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: invoice.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(invoice.title), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.moment(invoice.invoice_requested_at).format('MM/DD/YYYY')), 1),
                          _createElementVNode("td", null, [
                            (invoice.is_payment_made)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Complete"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Pending"))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary",
                              onClick: ($event: any) => (_ctx.router.push({name:'management.invoice',params:{invoice_id:invoice.id}}))
                            }, "View", 8, _hoisted_7)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_8, "No Invoice Requests Available"))
            ])
          ])
        ]))
      : (_ctx.has_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}